module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapNumber"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }, [_vm._v("CHAPTER 2")])]), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_vm._v("DIAGNOSES FOR MY DOCTOR")]), _vm._v(" "), _c('p', {
    staticClass: "CST"
  }, [_c('em', [_vm._v("Diversifying Can Be Tricky")])]), _vm._v(" "), _c('p', {
    staticClass: "DropCap"
  }, [_vm._v("One of my closest friends is a heart surgeon in Silicon Valley. And like many successful folks in 2000 to 2001, he often told anyone who would listen about his investing prowess. He had done so well with his investing over the past decade that he planned on retiring soon. I asked him if he was diversified, and he replied that his equity portfolio was quite diversified by industry, size of companies, and individual stocks and mutual funds. He had one-third of his portfolio in stocks he chose, with the balance divided among a variety of four highly rated stock funds and the Standard & Poor’s index fund. He put most of his money in equities, as he was impressed by his own stock-picking ability over the previous five years.")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "ch2"
    }
  }, [_vm._v("Soon afterward, I moved back overseas, mainly to buy a brokerage firm in South Korea, and I didn’t see him for a few years. Upon returning to the United States, we got together for dinner. He complained he would now have to work another five years due to his poor investment performance. After the dot.com bubble burst in 2001 and 2002, causing most of the technology and internet-oriented stock ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("prices to collapse, he lost nearly half his money. He asked me to help him figure out what went so wrong with his portfolio. After all, the Dow had only declined around 15 percent in the same time frame. In the 2000–2002 price plunge, the technology-heavy NASDAQ lost a whopping 66 percent.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("In studying the details of his portfolio, it became crystal clear that he had been lulled into a false sense of safe diversification. Indeed, he was correct that all his money was not in one investment portfolio, but instead was mixed up with other fund managers and some in indexing funds as well. So, what was his mistake? Why had his portfolio dropped so much more than the blue-chip market?")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("First off, his personal stock-picking portfolio was concentrated in large high-tech and internet stocks, many of which were naturally connected with Silicon Valley. During the OTC market crash, these stocks were crushed the most—many dropping as much as 90 percent. They were often valued in excess of 100 times annual earnings, so they had a lot of room to fall.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Second, the funds he chose were the top-rated performing funds of the previous five years. By definition, since the major high-tech stocks were the best performers in the late nineties, most of those funds were exposed to the very same stocks he bought in his own portfolio. Buying many of the highest-rated or multiple “stars” funds doubled his concentration risk rather than helping him to diversify. I was able to see firsthand how fund ratings can be quite misleading"), _c('sup', [_c('a', {
    attrs: {
      "id": "fan1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifan1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and should be evaluated very carefully to avoid overconcentration.")]), _vm._v(" "), _c('p', {
    staticClass: "Fig_Capt"
  }, [_c('a', {
    attrs: {
      "id": "ch2-fig_2-1"
    }
  }, [_c('strong', [_vm._v("Fig. 2.1")]), _vm._v("   Performance of NASDAQ vs. Dow Jones Industrial Average (1997–2001)")])]), _c('a', {
    attrs: {
      "id": "ch2-fig_2-1"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "335",
      "src": "html/images/fig2.1.jpg",
      "width": "536"
    }
  })])]), _c('p', {
    staticClass: "Fig_Capt"
  }, [_c('a', {
    attrs: {
      "id": "ch2-fig_2-1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2-fig_2-2"
    }
  }, [_c('strong', [_vm._v("Fig. 2.2")]), _vm._v("   Performance of Top-Rated Technology Funds* (1998–2001)")])]), _c('a', {
    attrs: {
      "id": "ch2-fig_2-2"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "378",
      "src": "html/images/fig2.2.jpg",
      "width": "563"
    }
  })])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "ch2-fig_2-2"
    }
  }, [_vm._v("Third, the major index fund, the Standard and Poor’s or S&P 500, like many index funds and ETFs (exchange traded funds), are “cap weighted,” i.e., the amount of shares bought for each stock is determined by the value of the company relative to the total market. So during the late nineties, though many people thought an index fund does not follow an investment strategy, it turns out that if you bought most index funds, they would be weighted or concentrated in the blue-chip momentum growth stocks."), _c('sup')]), _c('a', {
    attrs: {
      "id": "fan2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifan2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" After all, it is this group of stocks that will have the highest market values. Naturally, during the late nineties the large or blue-chip high-tech and internet stocks were indeed large-cap momentum growth stocks. So, my poor doctor friend ended up being triple concentrated—the index fund also had large concentrations of the same stocks he was buying and his funds were buying.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Take Sun Microsystems. It was a great company in the nineties with a high market value versus other companies. It had a major position in the doctor’s personal portfolio, as well as in most of his "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("funds due to its good performance, and had a large weighting naturally in the index portfolio. During the early 2000s crash, Sun fell around 85 percent from its peak and, for the most part, did not fully recover. No wonder my friend lost nearly half his money. All his different investments contained large portions of companies like Sun, but he did not realize he was so inadvertently concentrated.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Of course, the good doctor was not the only one who lost a lot of money at the beginning of this century. Over the years, I have met many smart and capable doctors as well as business professionals who were extremely successful in their careers, and yet lost fortunes due to their investing decisions. Indeed, even many full-time investment professionals have made serious mistakes in their own portfolios. It is not so easy to beat the market, and often, in trying to outperform, you can put your portfolio at risk.")]), _vm._v(" "), _c('p', {
    staticClass: "Fig_Captc"
  }, [_c('a', {
    attrs: {
      "id": "ch2-fig_2-3"
    }
  }, [_c('strong', [_vm._v("Fig. 2.3")]), _vm._v("   Rise and Fall of Sun Microsystems")])]), _c('a', {
    attrs: {
      "id": "ch2-fig_2-3"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "349",
      "src": "html/images/fig2.3.jpg",
      "width": "540"
    }
  })])]), _c('p', {
    staticClass: "Fig_Capt"
  }, [_c('a', {
    attrs: {
      "id": "ch2-fig_2-3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('strong', [_vm._v("Image 2.1")]), _vm._v("   The Good Doctor’s Patient Portfolio")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "432",
      "src": "html/images/img2.1.jpg",
      "width": "526"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "BOXTitle"
  }, [_c('strong', [_vm._v("THE LESSONS I LEARNED THROUGH MY DOCTOR FRIEND")])]), _vm._v(" "), _c('p', {
    staticClass: "BOXNList"
  }, [_c('strong', [_c('span', {
    staticClass: "ClassList"
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "disp"
  }), _vm._v("Diversifying can be much trickier than you think.")]), _vm._v(" Just like the doctor, you may think you are diversified because the investments are with different managers, or in different parts of the world, or even in different asset classes. But unless you and/or your advisor are regularly checking the details about how similar the underlying investments are, or how an event can affect all the exposures you have in your overall portfolio, don’t be surprised if you get surprised and are more concentrated than you think.")]), _vm._v(" "), _c('p', {
    staticClass: "BOXNList2"
  }, [_c('strong', [_c('span', {
    staticClass: "ClassList"
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "disp"
  }), _vm._v("Selecting a fund just by its rating doesn’t ensure success.")]), _vm._v(" Simply taking a rating on a fund, or looking at the last one-, three-, or even five-year performance of a fund or a manager often doesn’t help you much in selecting the right fund. In"), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" many cases the funds that had the highest ratings throughout the late nineties—had the best performance, were the highest in evaluations by experts—crashed the hardest by the end of 2002."), _c('sup', [_c('a', {
    attrs: {
      "id": "fan3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifan3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "BOXText"
  }, [_vm._v("If that’s the case, how then does one make the right choices?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5581da6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781137279101_03_ch02.vue
// module id = 63
// module chunks = 0